const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhiteP(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144.962,44.664c-0,-18.784 -15.228,-34.012 -34.012,-34.012c-20.781,0 -47.369,0 -68.694,0c-9.845,0 -19.286,3.911 -26.247,10.872c-6.961,6.961 -10.872,16.402 -10.872,26.247l0,57.727c0,9.006 3.578,17.643 9.946,24.012c6.369,6.368 15.006,9.946 24.012,9.946l69.513,-0c9.641,-0 18.888,-3.831 25.706,-10.648c6.817,-6.818 10.648,-16.065 10.648,-25.706c-0,-18.336 -0,-40.441 -0,-58.438Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.196,66.9l26.461,-0l-0,-56.219l-25.276,-0c-20.505,-0 -37.281,15.12 -37.281,33.599l-0,58.451c0.635,-8.951 3.008,-16.841 9.024,-24.078c6.175,-7.618 15.199,-11.537 27.072,-11.753Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.803,60.046c3.115,-3.936 4.673,-8.31 4.673,-13.121c-0,-3.991 -0.632,-7.353 -1.9,-10.088c-1.322,-2.459 -3.17,-4.4 -5.546,-5.822c-3.592,-2.35 -7.766,-3.471 -12.517,-3.362l-25.14,-0l-0,38.626l25.774,-0c6.495,-0.11 11.38,-2.187 14.656,-6.233Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.228,90.097c-3.116,3.936 -4.674,8.31 -4.674,13.12c-0,3.991 0.633,7.353 1.901,10.088c1.322,2.459 3.17,4.4 5.546,5.823c3.592,2.348 7.766,3.47 12.517,3.362l25.139,-0l-0,-38.627l-25.772,-0c-6.496,0.11 -11.381,2.188 -14.657,6.234Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.835,83.243l-26.462,-0l-0,56.218l25.278,-0c20.504,-0 37.281,-15.12 37.281,-33.599l-0,-58.451c-0,9.295 -3.009,16.841 -9.026,24.079c-6.174,7.618 -15.197,11.536 -27.071,11.753Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.196,66.9l26.461,-0l-0,-56.219l-25.276,-0c-20.505,-0 -37.281,15.12 -37.281,33.599l-0,58.451c0.635,-8.951 3.008,-16.841 9.024,-24.078c6.175,-7.618 15.199,-11.537 27.072,-11.753Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.803,60.046c3.115,-3.936 4.673,-8.31 4.673,-13.121c-0,-3.991 -0.632,-7.353 -1.9,-10.088c-1.322,-2.459 -3.17,-4.4 -5.546,-5.822c-3.592,-2.35 -7.766,-3.471 -12.517,-3.362l-25.14,-0l-0,38.626l25.774,-0c6.495,-0.11 11.38,-2.187 14.656,-6.233Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.228,90.097c-3.116,3.936 -4.674,8.31 -4.674,13.12c-0,3.991 0.633,7.353 1.901,10.088c1.322,2.459 3.17,4.4 5.546,5.823c3.592,2.348 7.766,3.47 12.517,3.362l25.139,-0l-0,-38.627l-25.772,-0c-6.496,0.11 -11.381,2.188 -14.657,6.234Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.835,83.243l-26.462,-0l-0,56.218l25.278,-0c20.504,-0 37.281,-15.12 37.281,-33.599l-0,-58.451c-0,9.295 -3.009,16.841 -9.026,24.079c-6.174,7.618 -15.197,11.536 -27.071,11.753Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteP);
export default __webpack_public_path__ + "static/media/logo_white_P.668c83fd05b12f465565ef61349bb8cf.svg";
export { ForwardRef as ReactComponent };